module.exports = __webpack_public_path__ + "img/banner01_zh-TW.04af089e.jpg";